<template>
    <div class="form">
        <Table ref="mt" :columns="columns" :data="list" :loading="loading" :height="mtHeight"></Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="totalCount"
            :pageSize.sync="page.pageSize"
            :pageNo.sync="page.pageNo"
            @change="fetch"
        ></table-pager>
        <smart-modal
            v-model="modal.showOrderInfo"
            :title="dataSource + '详情'"
            :width="800"
            :height="600"
            :maskClosable="false"
            :buttons="buttons"
        >
            <form-order v-if="modal.showOrderInfo" :id="curId"></form-order>
        </smart-modal>
    </div>
</template>
<script>
import Dict from '_u/dict'
import { mapCell, anchorCell } from '_c/grid/renderCell'
import { orderMonitor } from '@/api/order-manage'
import FormOrder from '@/views/order-manage/form-order'
const PAGE_SIZE = 20
export default {
    name: 'OrderInfoList',
    props: {
        filter: {
            type: Object,
            default: ()=> {}
        }
    },

    components: { FormOrder },

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            mtHeight: 480,
            loading: false,
            page: {
                pageNo: 1,
                pageSize: PAGE_SIZE
            },
            totalCount: 0,
            list: [],
            dict: {
                orderStatus: Dict.NULL,
                serviceType: Dict.NULL
            },
            modal: {
                showOrderInfo: false
            },
            curId: '',
            buttons: [
                {
                    type: 'default',
                    text: '关闭'
                }
            ]
        }
    },

    computed: {
        columns() {
            let that = this
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'orderNo',
                    title: '工单号',
                    align: 'left',
                    minWidth: 180,
                    render: anchorCell({
                        click(row, column, index) {
                            that.toShowInfo(row)
                        }
                    })
                },
                {
                    key: 'serviceType',
                    title: '服务类别',
                    align: 'center',
                    minWidth: 100,
                    render: mapCell(this.serviceTypeList)
                },
                {
                    key: 'orderStatus',
                    title: '状态',
                    align: 'center',
                    minWidth: 100,
                    render: mapCell(this.orderStatusList)
                }
            ]
        },
        serviceTypeList() {
            return this.dict.serviceType.val()
        },
        orderStatusList() {
            return this.dict.orderStatus.val()
        },
        dataSource() {
            return this.filter.orderDataSource == 'G' ? '工单' : '任务'
        }
    },

    methods: {
        fetch() {
            let body = Object.assign({}, this.filter)
            Object.assign(body, this.page)
            return orderMonitor(body)
        },
        setPageData(data) {
            let list = data.page.list || []
            list.forEach(el => {
                el.cellClassName = {
                    orderStatus: `order-status-color${el.orderStatus || 999}`
                }
            })
            this.list = list
            this.totalCount = parseInt(data.page.totalCount || 0)
        },
        toShowInfo(row) {
            this.curId = row.id
            this.modal.showOrderInfo = true
        },
    },

    mounted() {
        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([
                Dict.get(['service_type', 'order_status']),
                this.fetch()
            ])
                .then(args => {
                    var [dictGroup, monitor] = args

                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name]
                    })

                    this.setPageData(monitor.data)
                })
                .finally(() => {
                    next()
                })
        })
    }
}
</script>
